import { IImage, ILink, Languages } from "@/src/types";
import { graphql, useStaticQuery } from "gatsby";

export type IHeaderData = {
  links: {
    link: ILink;
    subLinks: {
      subLink: ILink;
    };
  }[];
  languageIcon: IImage;
  logo: IImage;
  searchIcon: IImage;
};

const useHeaderData = (lang: Languages): IHeaderData => {
  const { wp } = useStaticQuery(
    graphql`
      {
        wp {
          siteSettingsSV {
            header {
              links {
                link {
                  target
                  title
                  url
                }
                subLinks {
                  subLink {
                    target
                    title
                    url
                  }
                }
              }
              languageIcon {
                altText
                sourceUrl
                gatsbyImage(
                  placeholder: NONE
                  width: 2000
                  formats: [AUTO, WEBP]
                  layout: FULL_WIDTH
                )
              }
              logo {
                altText
                sourceUrl
                gatsbyImage(
                  placeholder: NONE
                  width: 2000
                  formats: [AUTO, WEBP]
                  layout: FULL_WIDTH
                )
              }
              searchIcon {
                altText
                sourceUrl
                gatsbyImage(
                  placeholder: NONE
                  width: 2000
                  formats: [AUTO, WEBP]
                  layout: FULL_WIDTH
                )
              }
            }
          }
          siteSettingsNO {
            header {
              links {
                link {
                  target
                  title
                  url
                }
                subLinks {
                  subLink {
                    target
                    title
                    url
                  }
                }
              }
              languageIcon {
                altText
                sourceUrl
                gatsbyImage(
                  placeholder: NONE
                  width: 2000
                  formats: [AUTO, WEBP]
                  layout: FULL_WIDTH
                )
              }
              logo {
                altText
                sourceUrl
                gatsbyImage(
                  placeholder: NONE
                  width: 2000
                  formats: [AUTO, WEBP]
                  layout: FULL_WIDTH
                )
              }
              searchIcon {
                altText
                sourceUrl
                gatsbyImage(
                  placeholder: NONE
                  width: 2000
                  formats: [AUTO, WEBP]
                  layout: FULL_WIDTH
                )
              }
            }
          }
          siteSettingsEN {
            header {
              links {
                link {
                  target
                  title
                  url
                }
                subLinks {
                  subLink {
                    target
                    title
                    url
                  }
                }
              }
              languageIcon {
                altText
                sourceUrl
                gatsbyImage(
                  placeholder: BLURRED
                  width: 2000
                  formats: [AUTO, WEBP]
                  layout: FULL_WIDTH
                )
              }
              logo {
                altText
                sourceUrl
                gatsbyImage(
                  placeholder: BLURRED
                  width: 2000
                  formats: [AUTO, WEBP]
                  layout: FULL_WIDTH
                )
              }
              searchIcon {
                altText
                sourceUrl
                gatsbyImage(
                  placeholder: BLURRED
                  width: 2000
                  formats: [AUTO, WEBP]
                  layout: FULL_WIDTH
                )
              }
            }
          }
        }
      }
    `
  );
  return wp[`siteSettings${lang.toUpperCase()}`].header;
};
export default useHeaderData;
